import { render } from "./FirstClient.vue?vue&type=template&id=ea8285c8"
import script from "./FirstClient.vue?vue&type=script&lang=js"
export * from "./FirstClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__